import { useEffect, useRef, useState } from 'react';

import { FeeType } from '@zg-rentals/ts-rental-manager-api-client';
import { useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import accessUtils from '../utils/accessUtils';

import type { ChangeEvent } from 'react';

type Options = {
  isMultifamily: boolean;
  isFeed: boolean;
};

export const useApplicationsFeeField = (listingAlias: string, { isMultifamily, isFeed }: Options) => {
  const canAccessSFCostsAndFees = accessUtils.canAccessSFCostsAndFees({ isMultifamily, isFeed });

  const { data: applicationFee = [] } = useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType(
    { feeType: FeeType.APPLICATION_FEE, listingAlias },
    {
      enabled: canAccessSFCostsAndFees && Boolean(listingAlias),
      meta: { tags: ['sf-applicationFee'], context: { api: 'rental-manager', details: 'getFeesForType' } },
    },
  );

  const serverFeeAmount = applicationFee?.length > 0 ? String(applicationFee[0].feeAmountMin ?? '') : '';

  const [feeAmount, setFeeAmount] = useState('');
  const [feeError, setFeeError] = useState('');
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!initializedRef.current && serverFeeAmount !== '') {
      initializedRef.current = true;
      setFeeAmount(serverFeeAmount);
    }
  }, [serverFeeAmount]);

  const validateFeeAmount = (value: string): string => {
    if (!value && value !== '0') return 'Amount cannot be blank';
    const num = Number(value);
    if (Number.isNaN(num) || num < 0) return 'Amount must be a non-negative number';
    return '';
  };

  const handleFeeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFeeAmount(event.target.value);
    setFeeError('');
  };

  return {
    canAccessSFCostsAndFees,
    feeAmount,
    feeError,
    setFeeError,
    validateFeeAmount,
    handleFeeChange,
  };
};
